<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <h6>{{ data ? 'Edit' : 'Add' }} Sysadmin</h6>
    <button matIconButton aria-label="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<mat-divider class="mx-20!" />

<form (ngSubmit)="saveUpdateSysadmin()" [formGroup]="sysadminForm">
  <div mat-dialog-content>
    <div class="name-line">
      <mat-form-field>
        <mat-label>Username</mat-label>
        <input formControlName="username" matInput required />
        @if (username.hasError('required')) {
          <mat-error> Username is <strong>required</strong> </mat-error>
        }
        @if (!username.valid && !username.hasError('required')) {
          <mat-error> This username already exists </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>First Name</mat-label>
        <input formControlName="firstName" matInput required />
        @if (firstName.hasError('required')) {
          <mat-error> First Name is <strong>required</strong> </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Last Name</mat-label>
        <input formControlName="lastName" matInput required />
        @if (lastName.hasError('required')) {
          <mat-error> Last Name is <strong>required</strong> </mat-error>
        }
      </mat-form-field>
    </div>
    <mat-form-field>
      <mat-label>Email</mat-label>
      <input formControlName="email" matInput required />
      @if (email.hasError('required')) {
        <mat-error> Email is <strong>required</strong> </mat-error>
      }
      @if (!email.valid && !email.hasError('required')) {
        <mat-error> Please enter a valid email address </mat-error>
      }
    </mat-form-field>
    @if (!data?.isActivated) {
      <div class="email-info mb-20!">
        <mat-icon>error_outline</mat-icon>
        <span>An email will be sent to this email address to complete account information</span>
      </div>
    }
  </div>

  <mat-divider class="mx-20!" />

  <mat-dialog-actions>
    <button matButton="elevated" class="charcoal-button" type="button" mat-dialog-close>CANCEL</button>
    <button matButton="elevated" class="red-button" type="submit" [disabled]="sysadminForm.invalid || pending()">
      {{ !data || (data && !data?.isActivated) ? 'INVITE' : 'SAVE' }}
    </button>
  </mat-dialog-actions>
</form>
